/**
 * Retira las cabeceras de respaldo del `index.html`.
 *
 * El `index.html` trae un titulo, una descripcion y unas etiquetas Open Graph
 * genericas para quien lee el HTML sin ejecutar JavaScript (WhatsApp y las redes
 * al armar la vista previa de un enlace).
 *
 * Apenas arranca la aplicacion hay que sacarlas, y no es cosmetico: un buscador
 * lee la PRIMERA `<meta name="description">` del documento. Si la generica se
 * quedara, cada ficha de producto publicaria esa descripcion en vez de la suya,
 * y el trabajo de `Seo.tsx` no serviria de nada.
 *
 * Se llama una sola vez, antes del primer render.
 */
export function retirarCabecerasDeRespaldo(): void {
  for (const etiqueta of document.head.querySelectorAll('[data-respaldo]')) {
    etiqueta.remove();
  }
}
